import React, { useState } from "react";
import { Box, Chip, TextField } from "@mui/material";

function normalizeValues(value) {
  if (Array.isArray(value)) return value.map(String).map((item) => item.trim()).filter(Boolean);
  return String(value || "").split(",").map((item) => item.trim()).filter(Boolean);
}

export default function MultiTagField({ value, onChange, required = false, ...props }) {
  const [draft, setDraft] = useState("");
  const values = normalizeValues(value);
  const inputRequired = required && values.length === 0;

  const emit = (nextValues) => {
    onChange?.({ target: { value: nextValues.join(", ") } });
  };

  const addDraft = (text = draft) => {
    const additions = normalizeValues(text);
    if (!additions.length) return;
    const seen = new Set(values.map((item) => item.toLocaleLowerCase()));
    const nextValues = [...values];
    additions.forEach((item) => {
      const key = item.toLocaleLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        nextValues.push(item);
      }
    });
    emit(nextValues);
    setDraft("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();
      addDraft();
    } else if (event.key === "Backspace" && !draft && values.length) {
      emit(values.slice(0, -1));
    }
  };

  return (
    <TextField
      {...props}
      required={inputRequired}
      value={draft}
      onChange={(event) => {
        const nextDraft = event.target.value;
        if (nextDraft.includes(",")) addDraft(nextDraft);
        else setDraft(nextDraft);
      }}
      onKeyDown={handleKeyDown}
      onBlur={() => addDraft()}
      slotProps={{
        ...props.slotProps,
        inputLabel: {
          ...props.slotProps?.inputLabel,
          required,
        },
        input: {
          ...props.slotProps?.input,
          startAdornment: values.length ? (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 0.5 }}>
              {values.map((item) => (
                <Chip
                  key={item}
                  label={item}
                  size="small"
                  onDelete={() => emit(values.filter((valueItem) => valueItem !== item))}
                />
              ))}
            </Box>
          ) : undefined,
          sx: {
            ...props.slotProps?.input?.sx,
            alignItems: "flex-start",
            flexWrap: "wrap",
          },
        },
      }}
    />
  );
}
